(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rw-tabs').forEach(tabs=>{const buttons=[...tabs.querySelectorAll('[role="tab"]')];const activate=b=>{buttons.forEach(x=>{const selected=x===b;x.setAttribute('aria-selected',String(selected));x.tabIndex=selected?0:-1;document.getElementById(x.getAttribute('aria-controls')).hidden=!selected})};buttons.forEach((b,i)=>{b.addEventListener('click',()=>activate(b));b.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%buttons.length;if(e.key==='ArrowLeft')n=(i-1+buttons.length)%buttons.length;if(e.key==='Home')n=0;if(e.key==='End')n=buttons.length-1;if(n!==undefined){e.preventDefault();activate(buttons[n]);buttons[n].focus()}})})});
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.rw-header details[open]').forEach(x=>x.removeAttribute('open'))});

  } catch(e) { console.error(e); }
})();
})();
